import { Grid } from '@simplywallst/ui-core';
import { Bones } from '@simplywallst/ui-core';

const PageSkeleton = () => (
  <div className="relative mt-x0 w-full max-w-screen-xl md:mt-x3">
    <Grid gap="16px">
      {/* header */}
      <Grid gap="16px">
        <Bones maxWidth="30%" minHeight="30px" />
        <Bones maxWidth="80%" minHeight="60px" />
        <Bones maxWidth="60%" minHeight="32px" />
      </Grid>
      {/* content block */}
      <Grid gap="16px">
        <Bones maxWidth="40%" minHeight="16px" />
        <Bones maxWidth="60%" minHeight="32px" />
        <Bones maxWidth="40%" minHeight="32px" />
        <Bones maxWidth="70%" minHeight="32px" />
        <Bones maxWidth="50%" minHeight="32px" />
        <Bones maxWidth="60%" minHeight="256px" />
        <Bones maxWidth="40%" minHeight="32px" />
      </Grid>
      {/* content block */}
      <Grid gap="16px">
        <Bones maxWidth="40%" minHeight="16px" />
        <Bones maxWidth="60%" minHeight="32px" />
        <Bones maxWidth="40%" minHeight="32px" />
        <Bones maxWidth="70%" minHeight="32px" />
        <Bones maxWidth="50%" minHeight="32px" />
        <Bones maxWidth="60%" minHeight="256px" />
        <Bones maxWidth="40%" minHeight="16px" />
        <Bones maxWidth="60%" minHeight="32px" />
        <Bones maxWidth="40%" minHeight="32px" />
        <Bones maxWidth="70%" minHeight="32px" />
        <Bones maxWidth="50%" minHeight="32px" />
      </Grid>
    </Grid>
  </div>
);

export default PageSkeleton;
